import React, { useState, useEffect } from "react";

import { useParams, useHistory } from "react-router-dom";

export default function EDA() {
  const [data, setData] = useState([]);
  let { uname, pname } = useParams();

  useEffect(() => {
    let val = Math.floor(1000 + Math.random() * 9000);
    fetch(
      `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${uname}/${pname}.html?temp=${val}`,
    )
      .then((response) => response.text())
      .then((data) => {
        // Do something with your data
        // console.log(data);
        data = data.replaceAll(
          "Pandas Profiling Report",
          "Exploratory Data Analysis Report",
        );
        data = data.replaceAll("Report generated with", "");
        data = data.replaceAll(
          "<a href=https://github.com/pandas-profiling/pandas-profiling>pandas-profiling</a>.",
          "",
        );
        setData(data);
      });
    // .then(async response => {
    //     const htmldata = await response.data;
    //     console.log(htmldata);
    //     // check for error response
    //     // if (!response.ok) {
    //     //     // get error message from body or default to response status
    //     //     const error = (data && data.message) || response.status;
    //     //     return Promise.reject(error);
    //     // }

    // })
    // .then((resp) => JSON.parse(resp))
    //   .then((data) => {
    //     setData(data);
    //     console.log(data);
    //   });
  }, []);

  return (
    // <></>
    //    <iframe srcDoc={`https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${uname}/${pname}.html`}/>
    <iframe
      style={{
        width: "100vw",
        height: "100vh",
        border: "0px",
        position: "fixed",
      }}
      srcDoc={data}
    />
  );
}
